export const APPRENTICESHIP = 1
export const TRAINEESHIP = 2
export const JOB = 3
